import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Select, { AriaOnFocus } from "react-select";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getLedgers, getPartyApi } from "api";
import moment from "moment";

// Table data

class LedgerReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      ledgerList: [],
      partyList: [],
      partyId: "",
      toDate: moment().format("YYYY-MM-DD"),
      fromDate: moment().subtract(1,"week").format("YYYY-MM-DD"),
      orderId: "",
      orderList: [],
      paymentStatus: "",
    };
  }

  async componentDidMount() {
    const jangadList = await getLedgers({
      page: this.state.page,
      limit: this.state.sizePerPage,
      type: "P",
      paymentStatus: this.state.paymentStatus,
      partyId: this.state.partyId,
    });
    if(jangadList && jangadList.data){
      this.setState({
        orderList: jangadList.data.ledger,
      });
    }
    
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    this.getStockList();
  }

  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: inputValue,
    });
    if(data && data.data) {
      this.setState({
        partyList: data.data.parties,
      });
    }
   
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }

  async getStockList() {
    const data = await getLedgers({
      page: this.state.page,
      limit: this.state.sizePerPage,
      type: "P",
      paymentStatus: this.state.paymentStatus,
      partyId: this.state.partyId,
      orderId: this.state.orderId,
      toDate: this.state.toDate,
      fromDate: this.state.fromDate
    });
    if(data && data.data) {
      this.setState({
        totalSize: data.data.count,
        ledgerList: data.data.ledger,
      });
    }
   
  }

  async getJangadList(inputValue) {
    const data = await getLedgers({
      page: this.state.page,
      limit: this.state.sizePerPage,
      type: "P",
      paymentStatus: this.state.paymentStatus,
      partyId: this.state.partyId,
      name: inputValue,
    });
    if(data && data.data){
      this.setState({
        orderList: data.data.ledger,
      });
    }
   
    if (Array.isArray(data.data.ledger))
      return [
        { label: "All", value: "" },
        ...data.data.ledger.map(x => {
          return { label: x.id, value: x.id };
        }),
      ];
    else return [];
  }

  render() {
    const promiseOptionsOrder = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getJangadList(inputValue));
        }, 0);
      });
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    const columns = [
      {
        dataField: "id",
        text: "#",
        sort: true,
        hidden: true,
      },
      {
        dataField: "id",
        text: `${this.props.t("Ledger Id")}`,
        sort: true,
      },
      {
        dataField: "fromDate",
        text: `${this.props.t("From Date")}`,
        sort: true,
      },
      {
        dataField: "toDate",
        text: `${this.props.t("To Date")}`,
        sort: true,
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row?.party?.name;
        },
      },
      {
        dataField: "cgst",
        text: `${this.props.t("CGST")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.gst / 2;
        },
      },
      {
        dataField: "sgst",
        text: `${this.props.t("SGST")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.gst / 2;
        },
      },
      {
        dataField: "totalCost",
        text: `${this.props.t("Total Cost")}`,
        sort: true,
        formatter: (cell, row) => {
          let cost = 0;
          row.ledgerDetails.map(x => {
            cost +=
              x.mainJangad.rate *
              x.mainJangad.jangads.reduce((prev, current) => {
                return prev.cycle < current.cycle ? prev : current;
              }).weight;
          });
          return cost;
        },
      },
      {
        dataField: "printStatus",
        text: `${this.props.t("Print Status")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.printStatus == true || row.printStatus == "Yes" ? (
            <button className="btn-success-green border-0 py-2 px-3 rounded">
              Yes
            </button>
          ) : (
            <button className="btn-danger-red border-0 py-2 px-3 rounded">
              No
            </button>
          );
        },
      },
      {
        dataField: "approveStatus",
        text: `${this.props.t("Approve Status")}`,
        sort: true,
        formatter: (cell, row) => {
          if (row.approveStatus == "Yes") {
            return (
              <button className="btn-success-green border-0 py-2 px-3 rounded">
                Yes
              </button>
            );
          } else if (row.approveStatus == "No") {
            return (
              <button className="btn-danger-red border-0 py-2 px-3 rounded">
                No
              </button>
            );
          } else if (row.approveStatus == "Pending") {
            return (
              <button className="btn-warning-yellow border-0 py-2 px-3 rounded">
                Pending
              </button>
            );
          }
        },
      },
      {
        dataField: "paymentStatus",
        text: `${this.props.t("Payment Status")}`,
        sort: true,
        formatter: (cell, row) => {
          if (row.paymentStatus == "Paid") {
            return (
              <button className="btn-success-green border-0 py-2 px-3 rounded">
                Paid
              </button>
            );
          } else if (row.paymentStatus == "Pending") {
            return (
              <button className="btn-warning-yellow border-0 py-2 px-3 rounded">
                Pending
              </button>
            );
          } else {
            return (
              <button className="btn-primary-blue border-0 py-2 px-3 rounded">
                Partial Pending
              </button>
            );
          }
        },
      },
      {
        dataField: "printDate",
        text: `${this.props.t("Print Date")}`,
        sort: true,
      },
      {
        dataField: "viewdetails",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div>
            <Link
              to={{
                pathname: "/generate-ledger",
                query: {
                  isEdit: 2,
                  data: row,
                },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>
            <Link
              to={{
                pathname: "/generate-ledger",
                query: {
                  isEdit: 3,
                  data: row,
                },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
      },
      {
        dataField: "printdetail",
        text: "Print",
        formatter: (cell, row) => (
          <Link
            to={{
              pathname: "/print-ledger-report",
              query: {
                isEdit: 2,
                data: row,
              },
            }}
          >
            <button className="py-2 px-2 border-0 rounded ms-2">
              <img src="images/dashboard-images/print.svg" />
            </button>
          </Link>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title

    const { history } = this.props;

    document.title = "admin-report";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.ledgerList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.ledgerList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t('Ledger')}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h3 className="text-black fw-bold">{this.props.t('Ledger')}</h3>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                      <label
                                        htmlFor="date"
                                        className="fs-5 fw-bold text-black pe-3"
                                      >
                                        {this.props.t("From Date")}:
                                      </label>
                                      <input
                                        type="date"
                                        className="fs-5 text-black border-0    "
                                        name="date"
                                        value={this.state.fromDate}
                                        onChange={e =>
                                          this.setState(
                                            { fromDate: e.target.value },
                                            () => this.getStockList()
                                          )
                                        }
                                      />
                                      <label
                                        htmlFor="date"
                                        className="fs-5 fw-bold px-0 px-md-3 text-black"
                                      >
                                        {this.props.t("To Date")}:
                                      </label>
                                      <input
                                        type="date"
                                        className="fs-5 text-black border-0"
                                        name="date"
                                        value={this.state.toDate}
                                        onChange={e =>
                                          this.setState(
                                            { toDate: e.target.value },
                                            () => this.getStockList()
                                          )
                                        }
                                      />
                                    </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Select Party")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>
                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => {
                                            if (e.value == "") {
                                              this.getJangadList(null);
                                            }
                                            this.getStockList();
                                          }
                                        );
                                      }}
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.orderList.map(x => {
                                          return {
                                            label: x.id,
                                            value: x.id,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Payment Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    this.setState(
                                      {
                                        paymentStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 10,
                                      },
                                      () => {
                                        this.getStockList();
                                      }
                                    );
                                  }}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  options={[
                                    { label: "All", value: "" },
                                    { label: "Paid", value: "Paid" },
                                    {
                                      label: "Pending",
                                      value: "Pending",
                                    },
                                    {
                                      label: "Partial Paid",
                                      value: "PartialPaid",
                                    },
                                  ]}
                                />
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    onTableChange={() => false}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <div className="row">
                      <div className="col-lg-12 text-end pt-3">
                        <Button
                          color="primary"
                          className="fs-4 w-xl"
                          type="submit"
                          onClick={() => history.push("/print-ledger-report")}
                          disabled={Array.isArray(this.state.ledgerList) && this.state.ledgerList.length}
                        >
                          Generate Ledger
                        </Button>
                      </div>
                    </div>
                    <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                      <div className="">
                        <h5>
                          {this.props.t("Showing")}{" "}
                          {(this.state.page - 1) * this.state.sizePerPage + 1} -{" "}
                          {this.state.totalSize < this.state.sizePerPage
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page >=
                              this.state.totalSize
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page}{" "}
                          of {this.state.totalSize}
                        </h5>
                      </div>
                      <div className="ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(LedgerReports);
